module.exports = __webpack_public_path__ + "img/person-x-fill.03d4d4ac.svg";